import { render, staticRenderFns } from "./Alter.vue?vue&type=template&id=6e16ff7c&"
import script from "./Alter.vue?vue&type=script&lang=js&"
export * from "./Alter.vue?vue&type=script&lang=js&"
import style0 from "./Alter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports